import {post} from "../utility/fetch-util";

/**
 * Send forgot password request, passing in return pag path for specific portal e.g. driver or customer portal
 * (return link calculated with host and context root from PUBLIC_URL (or without for dev))
 */
export const sendForgotPasswordRequest = async (userDetails, returnPage, progress) => {
    const port = window.location.port && window.location.port !== '' ? (':' + window.location.port) : '';
    let returnLink = null
    if(process.env.PUBLIC_URL.length === 0)
    {
        returnLink = window.location.protocol + '//' + window.location.hostname + port + '/#' + returnPage;
    }
    return post('/api/users/management/react/forgot-pwd-request', {returnLink: returnLink}, userDetails, progress);
}

/**
 * Updates user password using forgot-password token
 */
export const updateForgottenPassword = async (passwordDetails, progress) => {
    return post('/api/users/management/react/forgot-pwd-update', null, passwordDetails, progress);
}

/**
 * Updates user password using reset-password token
 */
export const updateResetPassword = async (passwordDetails, progress) => {
    return post('/api/users/management/react/reset-pwd-update', null, passwordDetails, progress);
}

/**
 * Updates user password using create-user token
 */
export const updateCreateUser = async (passwordDetails, progress) => {
    return post('/api/users/management/react/create-user-update', null, passwordDetails, progress);
}

/**
 * Verifies user email using verify-email token
 */
export const verifyEmail = async (tokenDetails, progress) => {
    return post('/api/users/management/react/verify-email', null, tokenDetails, progress);
}

/**
 * Updates user locale
 */
export const updateUserLocale = async (newLocaleCode) => {
    return post('/api/users/preferences/updatePortalLocale/' + newLocaleCode, null, null, null);
}

/**
 * Gets user's security questions
 */
export const getUserSecurityQuestions = async (tokenDetails) => {
    return post('/api/users/management/securityQuestions', null, tokenDetails);
}

/**
 * Validate security question responses
 */
export const validateUserQuestions = async (responses, progress) => {
    return post('/api/users/management/securityQuestions/validate', null, responses, progress);
}
